import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMembership } from '../actions/membershipActions';
import LeadForm from '../components/LeadForm';

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);

export default function MembershipDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const membership = useSelector(s => s.memberships.current);
  useEffect(() => { dispatch(fetchMembership(id)); }, [dispatch, id]);

  if (!membership || membership._id !== id) return <section className="section"><p>Loading…</p></section>;

  const photo = (membership.photos && membership.photos[0]) || `https://placehold.co/1200x675/0a1a2e/ffffff?text=${encodeURIComponent(membership.make + ' ' + membership.model)}`;

  return (
    <section className="section">
      <p className="crumbs"><Link to="/inventory">← Back to inventory</Link></p>
      <div className="detail-grid">
        <div>
          <div className="detail-photo" style={{ backgroundImage: `url(${photo})` }} />
          <h1>{membership.year} {membership.make} {membership.model}</h1>
          <p className="detail-price">{fmt(membership.price)}</p>
          <p className="muted">{(membership.mileage || 0).toLocaleString()} miles · {membership.bodyStyle} · {membership.fuelType} · {membership.transmission} · {membership.drivetrain}</p>
          <p>{membership.description}</p>
          {membership.features && membership.features.length > 0 && (
            <>
              <h3>Features</h3>
              <ul className="features">
                {membership.features.map(f => <li key={f}>{f}</li>)}
              </ul>
            </>
          )}
        </div>
        <aside>
          <LeadForm membership={membership} />
        </aside>
      </div>
    </section>
  );
}
